<template>
  <div>
    <h4 class="ui dividing header">
      Transactions Audit
    </h4>
    <abstractTable
      :columns="transactionsColumns"
      :data="computedTransactions()"
      :hasFooter="true"
      :classes="'ui very compact left aligned celled center aligned table'"
    >
      <template slot="footer">
        <th :colspan="3"></th>
        <th style="font-weight: bold;">
          {{ 
            transactionsStatment 
          }}
        </th>
      </template>
    </abstractTable>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable')
      .default
  },
  props: {
    transactions: {
      type: Array,
      required: true
    },
  },
  computed: {
    transactionsColumns () {
      return [
        { header: this.$t('id'), fieldName: 'id', show: true, filterable: true },
        { header: this.$t('description'), fieldName: 'description', show: true, filterable: false },
        { header: this.$t('paidAt'), fieldName: 'paid_at', show: true, filterable: false, width: '20%' },
        { header: this.$t('amount'), fieldName: 'amount', show: true, filterable: false, width: '20%' }
      ]
    },
    transactionsStatment () {
      return this.formatPrice((this.income - this.outcome), 2)
    },
    income () {
      return window._.sumBy(this.transactions, transaction => {
        return !transaction.is_purchase && Number(transaction.amount)
      })
    },
    outcome () {
      return window._.sumBy(this.transactions, transaction => {
        return transaction.is_purchase && Number(transaction.amount)
      })
    },
  },
  methods: {
    computedTransactions () {
      let formlatedTransactions = []

      window._.each(this.transactions, transaction => {
        formlatedTransactions.push({
          id: transaction.id,
          amount: this.formatPrice(transaction.amount),
          description: transaction.description || '-',
          paid_at: window.moment(transaction.paid_at).format('DD/MM/YYYY hh:mm a'),
          transaction_for: transaction.transactable
            ? this.$t(transaction.transactable.type.toLowerCase()) : '-',
          classes: transaction.is_purchase ? 'negative' : ''
        })
      })

      return formlatedTransactions
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/financial_system/daily_transactions_component/AllTransactions.vue